import MembersTable from "./MembersTable";

const MembersScreen = () => {
  return <MembersTable />;
};

export default MembersScreen;
